var map = {
	"./asset-hyperlink.json": 35407,
	"./blockquote.json": 91268,
	"./document.json": 43319,
	"./embedded-asset-block.json": 32766,
	"./embedded-entry-block.json": 96466,
	"./embedded-entry-inline.json": 50208,
	"./embedded-resource-block.json": 62892,
	"./embedded-resource-inline.json": 22525,
	"./entry-hyperlink.json": 29336,
	"./heading-1.json": 81846,
	"./heading-2.json": 63433,
	"./heading-3.json": 86100,
	"./heading-4.json": 16223,
	"./heading-5.json": 87307,
	"./heading-6.json": 20496,
	"./hr.json": 32312,
	"./hyperlink.json": 44945,
	"./list-item.json": 20319,
	"./ordered-list.json": 95209,
	"./paragraph.json": 17267,
	"./resource-hyperlink.json": 98132,
	"./table-cell.json": 66784,
	"./table-header-cell.json": 24027,
	"./table-row.json": 65905,
	"./table.json": 21280,
	"./text.json": 8014,
	"./unordered-list.json": 81969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37445;